module.exports = __webpack_public_path__ + "img/creditCard.da681f8.svg";